export const scrollTo = (id?: string, options?: ScrollIntoViewOptions) => {
  if (id) {
    if (typeof document !== 'undefined') {
      document.getElementById(id)?.scrollIntoView(options);
    }
  } else {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }
};
